import { useEffect } from "react";

import {
  getNavigationHistoryIconColor,
  useClientEventsHistoryFilter,
} from "entities/navigation";
import { Props } from "../index";

import { useMapContext } from "../context/map";
import usePreviousState from "common/hooks/usePreviousState";

import { polylineFactory } from "entities/map";

import {
  NavigationHistoryPathType,
  LOCATION_HISTORY_PATH_TYPES,
} from "entities/navigation";

const getNavigationHistoryPathZIndex = (value: NavigationHistoryPathType) =>
  ({
    [LOCATION_HISTORY_PATH_TYPES.tracked]: 1,
    [LOCATION_HISTORY_PATH_TYPES.parking]: 2,
    [LOCATION_HISTORY_PATH_TYPES.untracked]: 3,
  })[value] || 1;

export const useNavigationHistoryRoutes = (
  navigationHistoryPath: Props["navigationHistoryPath"],
  navigationHistoryRoutes: Props["navigationHistoryRoutes"],
  onChangeNavigationHistoryRoutes?: Props["onChangeNavigationHistoryRoutes"]
) => {
  const { map } = useMapContext();
  const prevRoutes = usePreviousState<Props["navigationHistoryRoutes"]>(
    navigationHistoryRoutes
  );
  const clientEventHistoryPathFilter = useClientEventsHistoryFilter();

  useEffect(() => {
    if (prevRoutes) {
      prevRoutes.forEach((prevRoute) => {
        prevRoute.delete();
      });
    }
    // eslint-disable-next-line
  }, [navigationHistoryRoutes]);

  useEffect(() => {
    if (map) {
      const routes = (navigationHistoryPath || [])
        .map(({ locations, type }, index, navigationHistoryPath) => {
          if (type === "Parking") {
            return null;
          }

          const path = locations.map(({ latitude, longitude }) => ({
            lat: latitude,
            lng: longitude,
          }));

          // Truck stop events are showed as blue marker on map.
          // The code cuts parking polyline from final result.
          const prevPath = navigationHistoryPath[index - 1];
          if (prevPath && prevPath.type === "Parking") {
            const { latitude, longitude } = prevPath.locations[0];
            path[0] = {
              lat: latitude,
              lng: longitude,
            };
          }

          const route = polylineFactory(map, {
            path,
            geodesic: true,
            strokeColor: getNavigationHistoryIconColor(
              type,
              clientEventHistoryPathFilter
            ),
            strokeOpacity: 1.0,
            strokeWeight: 5,
            zIndex: getNavigationHistoryPathZIndex(type),
            clickable: false,
          });

          return route;
        })
        .filter((x) => x !== null);

      if (onChangeNavigationHistoryRoutes) {
        //@ts-ignore
        onChangeNavigationHistoryRoutes(routes);
      }
    }
  }, [
    clientEventHistoryPathFilter,
    map,
    navigationHistoryPath,
    onChangeNavigationHistoryRoutes,
  ]);
};
